import { render } from "./SectionWhiteCube.vue?vue&type=template&id=b501fda0&scoped=true"
import script from "./SectionWhiteCube.vue?vue&type=script&lang=js"
export * from "./SectionWhiteCube.vue?vue&type=script&lang=js"

import "./SectionWhiteCube.vue?vue&type=style&index=0&id=b501fda0&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b501fda0"]])

export default __exports__